import React from "react";
import {
  Box,
  Chip,
  TablePagination,
} from "@mui/material";
import { Stack } from "@mui/system";
import { ROWS_PER_PAGE_OPTIONS } from "../constants/orderConstants";

/**
 * Pagination footer with total count and page controls
 * - Total count on the left
 * - TablePagination (with built-in Rows Per Page) on the right
 */
const PaginationFooter = ({
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  isTotalDomain=false
}) => {
  if (isLoading) return null;

  if (totalCount === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 2,
      }}
    >
      {/* Total count on the left */}
      <Stack direction="row" alignItems="center">
        {isTotalDomain ? 'Total Domain' : 'Total'} :&nbsp;
        <Chip
          sx={{ backgroundColor: "#5761FE", color: "white" }}
          label={totalCount}
        />
      </Stack>

      {/* TablePagination on the right - has built-in Rows Per Page selector */}
      <TablePagination
        sx={{
          border: "1px solid #f0f0f0",
          borderRadius: 2,
        }}
        component="div"
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        count={totalCount}
        page={page}
        onPageChange={onPageChange}
      />
    </Box>
  );
};

export default PaginationFooter;